import request from '@/utils/request'
const cartApi = {
  queryCheckCiam: (data) => {
    return request({
      url: '/client/check/ciam',
      method: 'post',
      data
    })
  },
  queryCartBuy: (data) => {
    return request({
      url: '/cart/buy',
      method: 'post',
      data
    })
  },
  // 查看购物车
  getCartList: (params) => {
    return request({
      url: '/cart/list',
      method: 'get',
      params
    })
  },
  // 购物车修改礼品数量
  updateCar: (data) => {
    return request({
      url: '/cart/update',
      method: 'post',
      data
    })
  },
  queryCartMax: (params) => {
    return request({
      url: '/cart/max',
      method: 'get',
      params
    })
  },
  checkSettlement: (data) => {
    return request({
      url: '/cart/settlement-check',
      method: 'post',
      data
    })
  },
  // 订单创建获取初始化数据
  initCreateOrder: (params) => {
    return request({
      url: '/order/create/init',
      method: 'get',
      params
    })
  },
  checkCreate: (data) => {
    return request({
      url: '/order/create/check',
      method: 'post',
      data
    })
  },
  createOrder: (data) => {
    return request({
      url: '/order/create',
      method: 'post',
      data
    })
  },
  removeCart: (data) => {
    return request({
      url: '/cart/remove',
      method: 'post',
      data
    })
  },
  // 我的订单
  getOrderList: (params) => {
    return request({
      url: '/order/list',
      method: 'get',
      params
    })
  },
  // 取消订单
  cancelOrder: (data) => {
    return request({
      url: '/order/item/return',
      method: 'post',
      data
    })
  },
  getKeywordList: (params) => {
    return request({
      url: '/item/keyword/show/list',
      method: 'get',
      params
    })
  },
  // 获取签到列表
  getSignList: (params) => {
    return request({
      url: '/client/sign/list',
      method: 'get',
      params
    })
  },
  // 签到
  signIn: (data) => {
    return request({
      url: '/client/sign',
      method: 'post',
      data
    })
  },
  // 积分嘉年华接口地址
  CarnivalSubmit: (data) => {
    return request({
      url: '/public/activity/202310Carnival/submit',
      method: 'post',
      data
    })
  }

}
export default cartApi
